import {type Data} from '@wix/component-protocol/schema'
type DataItem = Data['string']
type VideoCategoryTypes = NonNullable<
  NonNullable<DataItem['video']>['category']
>
type ImageCategoryTypes = NonNullable<
  NonNullable<DataItem['image']>['category']
>
type VectorArtCategoryTypes = NonNullable<
  NonNullable<NonNullable<DataItem['vectorArt']>['category']>
>

export interface ImageMediaResult {
  uri: string
  title: string
  width: number
  height: number
}

export interface DocumentMediaResult {
  uri: string
  title: string
  fileUrl: string
}

export interface VideoMediaResult {
  id: string
  title: string
  posterUri: string
  posterWidth: number
  posterHeight: number
}

/**
 * @doc Editor
 */
export enum MediaType {
  Image = 'IMAGE',
  Video = 'VIDEO',
  Document = 'DOCUMENT',
}

export type MediaTypeStrings = 'IMAGE' | 'VIDEO' | 'DOCUMENT'

export type SelectMediaCategoryType =
  | `${ImageCategoryTypes}`
  | `${VideoCategoryTypes}`
  | `${VectorArtCategoryTypes}`
